import { PlotDetailsPanel } from '../../../sites/components/panel/organisms/PlotDetailsPanel';

interface PlotDrawerContentProps {
  plotId: number;
}

export function PlotDrawerContent({ plotId }: PlotDrawerContentProps) {
  return <PlotDetailsPanel plotId={plotId} />;
}
